// extracted by mini-css-extract-plugin
module.exports = {"Video":"PromoVideo_Video__2E0vx","Div":"PromoVideo_Div__1Ic2O"};